<template>
  <a-form-model
          style="background: #ffffff;min-height:900px;padding-top: 20px;"
          ref="ruleForm"
          :model="form"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
  >

    <a-form-model-item ref="name" label="采样点名称" prop="name">
      <a-input
              placeholder="请输入采样点名称"
              v-model="form.name"
              :disabled="show == 1 ? true : false"
              @blur="
          () => {
            $refs.name.onFieldBlur();
          }
        "
      />
    </a-form-model-item>
    <a-form-model-item ref="code" label="采样点编码" prop="code">
      <a-input
              placeholder="请输入采样点编码"
              v-model="form.code"
              :disabled="show == 1 ? true : false"
              @blur="
          () => {
            $refs.code.onFieldBlur();
          }
        "
      />
    </a-form-model-item>

    <a-form-model-item
            :wrapper-col="{ span: 8, offset: 8 }"
            style="text-align: center;"
    >
      <a-button type="primary" @click="onSubmit" v-if="!id && !show">
        立即创建
      </a-button>
      <a-button type="primary" @click="onSubmit" v-if="id && !show">
        立即修改
      </a-button>
      <a-button style="margin-left: 10px;" @click="resetForm">
        取消
      </a-button>
    </a-form-model-item>
  </a-form-model>
</template>
<script>
import { addDemo, demoInfo, updateDemo } from "@/api/demo/demo";

export default {
  data() {
    return {
      labelCol: { span: 8 },
      wrapperCol: { span: 8 },
      other: "",
      form: {
        name: "",
        code: ""
      },

      showSearch: {
        filter: (inputValue, path) => {
          return path.some(option => {
                    // label搜索
                    return fullText(inputValue, option.label);
                  }
          )
        },
        matchInputWidth: true
      },

      demoList:[],

      id: 0,
      show: 0,

      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        code: [{ required: true, message: "请输入编码", trigger: "blur" }],
      }
    };
  },
  created() {

    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      demoInfo({
        demoId: this.id
      }).then(res => {
        if (res.code == 0) {
          this.form.name = res.data.name;
          this.form.code = res.data.code;
        }
      });
    }
    if (this.$route.query.show) {
      this.show = this.$route.query.show;
    }
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {

        if (valid) {
          if (this.id) {
            this.updateDemo();
          } else {
            this.addDemo();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addDemo() {
      let _this = this;

      addDemo({
        name: _this.form.name,
        code: _this.form.code,
        status: 1
      }).then(res => {
        if (res.code == 0) {
          _this.$message.success("新增成功", function() {
            _this.$router.push({ path: "/index/auth/demolist" });
          });
        } else {
          _this.$message.error(res.message);
        }
      });
    },
    updateDemo() {
      let _this = this;
      let data = {
        id: _this.id,
        name: _this.form.name,
        code: _this.form.code
      };

      updateDemo(data).then(res => {
        if (res.code == 0) {
          _this.$message.success("编辑成功", function() {
            _this.$router.push({ path: "/index/auth/demolist" });
          });
        } else {
          _this.$message.error(res.message);
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
      this.$router.push({ path: "/index/auth/demolist" });
    }
  }
};
</script>

<style scoped>
  .password-ok {
    position: absolute;
    top: -10px;
    left: -80px;
    color: red;
  }
</style>
